<template>
  <div class="modal-roomlist">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">床位修改</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body">
        <el-form :model="editForm" :rules="rules" ref="editForm">
          <div>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="房间" required prop="roomCode" style="width:100%">
                  <el-cascader
                      v-model="roomCodeList"
                      placeholder="请选择房间"
                      :options="options"
                      :key="cascaderKey"
                      @change="handleChange"  style="width:100%"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="床位号" required prop="number">
                  <el-input v-model="editForm.number"  placeholder="请输入床位"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
<!--            <el-row>-->
<!--              <el-col :span="12" class="item">-->
<!--                <el-form-item label="床位状态" required prop="status">-->
<!--                  <el-select v-model="editForm.status" placeholder="选择床位状态" @change="changeStatus" style="width:100%">-->
<!--                    <el-option-->
<!--                        v-for="item in statusValue"-->
<!--                        :key="item.val"-->
<!--                        :label="item.name"-->
<!--                        :value="item.val">-->
<!--                    </el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
          </div>

        </el-form>


      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'Edit',
  props: ["options"],
  data() {
    return {
      loading: false,
      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        roomCode:'',
        berthCode:'',
        number:'',
        status:''
      },
      cascaderKey:1,
      roomCodeList:[],
      buildingCode:'',
      statusValue:[{
        val:0,
        name:'未入住'
      },{
        val:1,
        name:'已入住'
      },{
        val:11,
        name:'禁用'
      }],
      buildingCodeValue:[],
      rules:{
        number:[
          { required: true, message: '请输入床位号', trigger: 'blur' },
        ],
        roomCode:[
          { required: true, message: '请选择房间', trigger: 'blur' },
        ]
      }

    }
  },

  methods: {

    init(row){
      this.editForm.number = row.number;
      this.editForm.berthCode = row.berthCode;
      this.editForm.roomCode = row.roomCode;
      this.editForm.status = row.status;
      var roomCodeList=[];
      roomCodeList[1]=row.roomCode;
      this.roomCodeList = roomCodeList;
      ++this.cascaderKey
    },
    handleChange(value) {
      this.editForm.roomCode=value[1];
      console.log(this.editForm.roomCode);
    },
    changeStatus:function (selVal) {
      this.editForm.status = selVal;
    },

    closeSelf() {
      this.$emit("closeEdit");
    },

    confirm(editForm){
      this.$refs[editForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })


    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Berth/Edit",
        data: this.editForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },

  }
}


</script>





<style lang="scss" scoped>

.modal-roomlist {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {

    background-color: #fff;
    box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x:auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 600px;



    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }
    .modal-body {
      position: relative;
      padding: 20px 0px;
      z-index: 99;
      height: 100%;
    }
    .modal-footer {
      border-top: 1px solid #eee;
      justify-content: flex-end;
      padding: 15px;
      display: flex;
    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left:16px;
  width:56px;
  height: 36px;
  border:none;
  cursor: pointer;
}
.btn-close {
  color: #313131;
  background-color:transparent;
}



.row{
  padding: 10px 0px;
}
.item{
  padding: 0px 20px;
}
.label{
  padding: 5px 0px;
}


</style>
